import React from "react";
import { SubUser } from "../../../_metronic/layout/components/account/accountSubUser/SubUser";

export const SubUserPage = () => {
  return <SubUser />;
};
